<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <h5 class="mb-0" style="color: #fff">
            <strong>{{ $store.state.table.persetujuan }}</strong>
          </h5>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable
              :items="items"
              :fields="fields"
              responsive
              sorter
              column-filter
              hover
              show-empty
              :loading="loading"
              @update:column-filter-value="onFilter($event)"
            >
              <template #namaTanggalDibuatSurat-filter>
                <date-picker
                  style="width: 100%"
                  v-model="filter.tanggalDibuatSurat"
                  format="DD MMMM YYYY"
                ></date-picker>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    variant="info"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Detail'"
                    v-b-modal.modal-detail
                    @click="(data = item), setEdit()"
                    ><CIcon name="cil-info" /></b-button
                  >
                  <b-button
                    variant="success"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Upload'"
                    v-b-modal.modal-upload
                    @click="(data = item), setEdit(), (load = !load)"
                    :disabled="!isSuper && !item.mitraId"
                    ><CIcon name="cil-paperclip" /></b-button
                  >

                  <b-button
                    variant="secondary"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Print Data'"
                    v-b-modal.modal-print
                    @click="prints(item)"
                    ><CIcon name="cil-print" /></b-button
                  >
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <ModalInput :karyawan="listKaryawan" :mitra="listMitra" @alert="triggerAlert($event)" />
    <ModalEdit :data="data" :edit="edit" :karyawan="listKaryawan" :mitra="listMitra" @alert="triggerAlert($event)" />
    <ModalDetail :data="data" :detail="detail" />
    <ModalUpload :data="data" :detail="detail" :load="load" @alert="triggerAlert($event)" />
    <ModalPrint :printData="printData" />
  </CRow>
</template>

<script>
import ModalInput from "./modalInput.vue";
import ModalEdit from "./modalEdit.vue";
import ModalUpload from "./modalUpload.vue";
import ModalPrint from "./modalPrint.vue";
import ModalDetail from "./modalDetail.vue";

export default {
  components: {
    ModalEdit,
    ModalDetail,
    ModalInput,
    ModalUpload,
    ModalPrint,
  },
  name: "persetujuan",
  data() {
    return {
      edit: false,
      detail: false,
      load: false,
      printData: {},
      data: {},
      listKaryawan: [],
      listMitra: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama Karyawan",
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "nomorSurat",
          label: "Nomor Surat",
          _style: "max-width: 40%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalDibuatSurat",
          label: "Tanggal Surat Persetujuan",
          _style: "max-width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {
        tanggalDibuatSurat: null
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    isSuper() {
      return this.$store.state.role_aktif.kodeRole == 'super';
    },
  },
  mounted() {
    if(this.$store.state.role_aktif.kodeRole == 'super'){
      this.fields.splice(1, 0, { 
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      })
    }
    this.getDatas();
    this.getKaryawan();
    this.getMitra();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    'filter.tanggalDibuatSurat'(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPersetujuan = await vm.$axios.post("suratPersetujuan/listPerHalaman", {
        ...vm.filter,
        tanggalDibuatSurat: vm.filter.tanggalDibuatSurat ? vm.$moment(vm.filter.tanggalDibuatSurat).format('YYYY-MM-DD') : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listPersetujuan", listPersetujuan);
      vm.items = listPersetujuan.data.status == 200 ? listPersetujuan.data.data.map((x, idx) => { 
        return {
          ...x,
          no: (vm.currentPage - 1) * vm.perPage + idx + 1,
          id: x.suratPersetujuanId, 
          namaMitra: x.namaMitra || ' - ',
          namaTanggalDibuatSurat: vm.$moment(x.tanggalDibuatSurat).format('LL'),
        }
      }): [];
      vm.totalRows = parseInt(listPersetujuan.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.get("dataKaryawan/listKaryawan");
      // console.log('listKaryawan', listKaryawan)
      vm.listKaryawan = listKaryawan.data.status == 200 ? listKaryawan.data.data.map(x=>{
        return {
          ...x,
          namaKaryawan: x.namaKaryawan + " - " + x.penempatan
        }
      }) : [];
    },
    async getMitra() {
      let vm = this;
      let listMitra = await vm.$axios.get("mitra/list");
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    },
    setEdit() {
      let vm = this;
      vm.detail = !vm.detail;
      vm.edit = !vm.edit;
      // FOREACH diganti FOR
      // vm.karyawan.forEach((ele) => {
      //   if (vm.data.dataKaryawanId == ele.dataKaryawanId) {
      //     vm.data.dataKaryawanIdEdit = ele;
      //   }
      //   vm.data.tanggalKontrakEdit = moment(vm.data.tanggalKontrak).format(
      //     "DD/MM/YYYY"
      //   );
      // });
      for (let i = 0; i < vm.listKaryawan.length; i++) {
        if (vm.data.dataKaryawanId == vm.listKaryawan[i].dataKaryawanId) {
          vm.data.dataKaryawanIdEdit = vm.listKaryawan[i];
        }
        vm.data.tanggalDibuatSuratEdit = vm.$moment(vm.data.tanggalDibuatSurat).format("DD/MM/YYYY");
      }
    },
    prints(x){
      const vm = this
      // console.log(x)
      x.tanggal = vm.$moment(x.tanggalDibuatSurat).format('lll')
      vm.printData = x
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({name, data}){
      this[name] = data
    }
  },
};
</script>
